'use client';

import { Containers, Widgets } from '@components';
import { CompanySubnav } from '@/components/elements/CompanySubnav';

export default function AdvisoryBoardPage() {
    return (
        <>
            <CompanySubnav currentLabel="Advisory Board" />
            <Containers.Section el={<Widgets.HeroOvalDivider color="brand-100" />} />
            <Containers.Section el={<Widgets.AdvisoryBoard />} />
            <Containers.Section el={<Widgets.ReadToBuild />} />
        </>
    );
}

